import React from 'react';
import { ContractSigningStatus } from '../types';

type StatusMap = {
  [K in ContractSigningStatus]: {
    label: string;
    classes: string;
  };
};

const statusMap: StatusMap = {
  INIT: {
    label: 'Pendiente',
    classes: 'bg-gray-blue-200',
  },
  PROGRESS: {
    label: 'En proceso',
    classes: 'bg-warning',
  },
  LAPSED: {
    label: 'Caducado',
    classes: 'bg-danger',
  },
  FAILED: {
    label: 'Fallido',
    classes: 'bg-danger',
  },
  SIGNED: {
    label: 'Firmado',
    classes: 'bg-success',
  },
};

export function StatusBadge({ status }: { status: ContractSigningStatus }) {
  const { label, classes } = statusMap[status];

  return (
    <span className={`badge badge-pill fs-xs text-center fw-semibold d-inline ${classes}`}>{label}</span>
  );
}
